import React, { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

type Locale = 'fr' | 'en';

interface IProps {
  isShowingRequiredSymbol?: boolean;
  maskChar?: string;
  phoneMask?: string;
  postalCodeMask?: string;
  dateFormat?: string;
  datePlaceholder?: string;
  calendarStartDay?: number;
  labelsNamespace?: string;
  validationNamespace?: string;
  children: ReactNode | ReactNode[];
}

const defaultMaskChar = '_';
const defaultPhoneMask = '999 999-9999';
const defaultPostalCodeMask = 'a9a 9a9';
const defaultDateFormat = 'yyyy-MM-dd';
const defaultCalendarStartDay = 0;
const defaultLabelsNamespace = 'forms';
const defaultValidationNamespace = 'validation';

export const FormProvider = React.createContext({
  locale: 'en' as Locale,
  isShowingRequiredSymbol: true,
  maskChar: defaultMaskChar,
  phoneMask: defaultPhoneMask,
  postalCodeMask: defaultPostalCodeMask,
  dateFormat: defaultDateFormat,
  calendarStartDay: defaultCalendarStartDay,
  labelsNamespace: defaultLabelsNamespace,
  validationNamespace: defaultValidationNamespace,
});

function FormProviderElement({
  isShowingRequiredSymbol = true,
  maskChar = defaultMaskChar,
  phoneMask = defaultPhoneMask,
  postalCodeMask = defaultPostalCodeMask,
  dateFormat = defaultDateFormat,
  calendarStartDay = defaultCalendarStartDay,
  labelsNamespace = defaultLabelsNamespace,
  validationNamespace = defaultValidationNamespace,
  children,
}: IProps) {
  const { i18n } = useTranslation();
  const locale = i18n.language as Locale;

  return (
    <FormProvider.Provider
      value={{
        locale,
        isShowingRequiredSymbol,
        maskChar,
        phoneMask,
        postalCodeMask,
        dateFormat,
        calendarStartDay,
        labelsNamespace,
        validationNamespace,
      }}
    >
      {children}
    </FormProvider.Provider>
  );
}

export default FormProviderElement;
